<template>
    <b-card>
        
    </b-card>
</template>
<script>
export default {
    name:"CustomerData"
}
</script>